import React from "react";
import { Dumbbell, Heart, Flame } from "lucide-react";

const items = [
  {
    icon: Dumbbell,
    title: "Train Together",
    body: "Find someone who pushes you to be better — through every set, every rep, every day.",
  },
  {
    icon: Heart,
    title: "Real Chemistry",
    body: "Built on shared goals, not just looks. Connect with people who get the grind.",
  },
  {
    icon: Flame,
    title: "Stay Consistent",
    body: "Motivation hits different together. Show up for each other and stack the wins.",
  },
];

const ValueProps = () => {
  return (
    <section
      id="how"
      data-testid="value-props-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="container mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-2xl mb-16 md:mb-20">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C6FF00] font-semibold mb-4">
            Why Swolemates
          </p>
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white leading-[0.95]">
            More than a swipe.
            <br />
            <span className="text-neutral-500">A spotter for life.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`value-card-${i}`}
                className="group relative bg-[#111111] border border-white/5 rounded-2xl p-8 hover:border-[#C6FF00]/40 transition-all duration-500 hover:-translate-y-1 overflow-hidden"
              >
                <div className="absolute -top-20 -right-20 w-48 h-48 bg-[#C6FF00]/0 group-hover:bg-[#C6FF00]/10 blur-3xl transition-all duration-700" />

                <div className="relative w-14 h-14 rounded-xl bg-[#C6FF00]/10 border border-[#C6FF00]/30 flex items-center justify-center mb-8">
                  <Icon className="text-[#C6FF00]" size={26} strokeWidth={2} />
                </div>

                <h3 className="font-heading text-3xl md:text-4xl text-white mb-3 tracking-wide">
                  {it.title}
                </h3>
                <p className="text-sm md:text-base text-neutral-400 leading-relaxed max-w-sm">
                  {it.body}
                </p>

                <div className="mt-8 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-neutral-500 group-hover:text-[#C6FF00] transition-colors">
                  <span className="font-bold">0{i + 1}</span>
                  <span className="h-px flex-1 bg-white/10 group-hover:bg-[#C6FF00]/40 transition-colors" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
